import { literal, number, object } from "superstruct";

export const PointsRewardSchema = object({
    type: literal("points"),
    points: number(),
});
